import { defaultTheme } from '../../../theming/data/defaultTheme'
import border from '../../../tokens/v2/border'
import fonts from '../../../tokens/fonts'
import layout from '../../../tokens/v2/layout'
import styled from 'styled-components'
import typography from '../../../tokens/v2/typography'
import { composeTheme } from '../../../utils/compose-theme'

export const Announcement = styled.div.attrs((props) => composeTheme(props))`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'inline-block')};
  padding: ${layout.spacing.xxxs};
  background-color: ${(props) =>
    props.theme.sideMenuAlt.announcementBackground};
  border-radius: ${border.radius.medium};
  max-height: 23rem;
  width: 90%;

  &.closeTheme {
    display: none;
  }
`

export const CloseButton = styled.div.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.sideMenuAlt.announcementColor};
  margin: ${layout.spacing.xmc};
  cursor: pointer;
`
export const Container = styled.div``

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.div.attrs((props) => composeTheme(props))`
  font-size: ${typography.fontSize.small};
  font-weight: ${typography.fontWeight.medium};
  line-height: ${typography.fontHeight.small};
  color: ${(props) => props.theme.sideMenuAlt.announcementTitleColor};
  font-family: ${fonts.inter};
  margin: ${layout.spacing.xmc} ${layout.spacing.none};
`

Announcement.defaultProps = defaultTheme
CloseButton.defaultProps = defaultTheme
Title.defaultProps = defaultTheme
